// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2ovG0","content":"RecentSearches_content__3AWCd"};